
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class POSQuotationDialog extends _Ext.TransDialog<POSQuotationRow, any> {

        protected getFormKey() { return POSQuotationForm.formKey; }
        protected getIdProperty() { return POSQuotationRow.idProperty; }
        protected getLocalTextPrefix() { return POSQuotationRow.localTextPrefix; }
        protected getNameProperty() { return POSQuotationRow.nameProperty; }
        protected getService() { return POSQuotationService.baseUrl; }
        protected getDeletePermission() { return POSQuotationRow.deletePermission; }
        protected getInsertPermission() { return POSQuotationRow.insertPermission; }
        protected getUpdatePermission() { return POSQuotationRow.updatePermission; }
        private myToolDropdownButton: J.ToolDropdownButton;
        protected useViewMode() { return true; }

        public form = new POSQuotationForm(this.idPrefix);
        statement: string;
        contractTotals: string;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public useMF: boolean;
          

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            //    q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //  q.setGridEditorHeight(this.form.TaxDetails, 150);
            // q.hideEditorToolbar(this.form.TaxDetails.getGridField());

            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.setTextRightAlign(this.form.MF);

            q.hideCaption(this.form.CustomerName);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true }); 
            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);
                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    this.form.POSCustomerId.value = CustomerDetails.POSCustomerId.toString();

                    this.form.Address.value = CustomerDetails.Address;
                    this.form.BirthDate.value = CustomerDetails.BirthDate;
                    this.form.Anniversary.value = CustomerDetails.Anniversary;
                    this.form.Mobile.value = parseFloat(CustomerDetails.Mobile);
                    this.form.PanNumber.value = CustomerDetails.PanNumber;
                }
            });
            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            this.form.MF.changeSelect2(e => {
                var mf = this.form.MF.value;
                if (mf < 50) {

                    Q.notifyWarning('MF cannot be less than 50');
                    this.form.MF.value = 50;
                    return;
                }
            });


            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

               
                this.CalculateAmountandTax(Items );
                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                if (items.length > 0)
                    q.showAndDisableField(this.form.MF);
                else {
                    if (this.useMF)
                        q.showAndSetRequiredField(this.form.MF);
                }
                    
            })
            let combineButtons: J.ToolDropdownButtonItem[] = [

                {
                    key: "estimateexcel",
                    title: 'Estimate Excel',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimateExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value
                            },

                            target: '_blank'
                        });
                    }
                }
                //,
                //{
                //    key: null,
                //    isSeparator: true
                //}, {
                //    key: "estimatepdf",
                //    title: 'Estimate PDF',
                //    icon: "",
                //    cssClass: "text-black",
                //    onClick: e => {
                         
                //    }
                //}
                ,
                {
                    key: null,
                    isSeparator: true
                }, {
                    key: "bifurcation",
                    title: 'Bifurcation PDF',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimatePriceBifurcationExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value,
                                VoucherDate: this.form.TransDate.value,
                                CustomerName: this.entity.CustomerName,
                                IsPDF:true
                            },

                            target: '_blank'
                        });
                    }

                },{
                    key: null,
                    isSeparator: true
                }, {
                    key: "bifurcationexcel",
                    title: 'Bifurcation Excel',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimatePriceBifurcationExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value,
                                VoucherDate: this.form.TransDate.value,
                                CustomerName: this.entity.CustomerName,
                                IsPDF: false
                            },

                            target: '_blank'
                        });
                    }

                }, {
                    key: null,
                    isSeparator: true
                }, {
                    key: "estimatewithoutratesexcel",
                    title: 'Estimate Without Rates(Excel)',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimateWithoutRateExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value,
                                VoucherDate: this.form.TransDate.value,
                                CustomerName: this.entity.CustomerName,
                                IsPDF: false
                            },

                            target: '_blank'
                        });
                    }

                }, {
                    key: null,
                    isSeparator: true
                }, {
                    key: "estimatewithoutratespdf",
                    title: 'Estimate Without Rates(PDF)',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimateWithoutRateExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value,
                                VoucherDate: this.form.TransDate.value,
                                CustomerName: this.entity.CustomerName,
                                IsPDF: true
                            },
                            target: '_blank'
                        });
                    }

                }, {
                    key: null,
                    isSeparator: true
                }, {
                    key: "estimatecatalogpdf",
                    title: 'Estimate Catalog',
                    icon: "",
                    cssClass: "text-black",
                    onClick: e => {
                        Q.postToService({
                            service: POSQuotationService.baseUrl + '/EstimateWithRateExcelExport',
                            request: {
                                Items: this.entity.ItemDetails,
                                VoucherNo: this.form.VoucherNo.value,
                                VoucherDate: this.form.TransDate.value,
                                CustomerName: this.entity.CustomerName,
                                IsPDF: true
                            },
                            target: '_blank'
                        });
                    }

                }

            ];

            this.myToolDropdownButton = new J.ToolDropdownButton(this.toolbar.element.find(".buttons-outer"), combineButtons, {
                title: "Export",
                icon: "fa-file-import"
            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });
            this.validateForm();

        } 

        public CalculateAmountandTax(Items: any) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ItemTotal = 0;
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;
                if (x.HSN != null || x.HSN != "NA") {
                    var temp = false;
                    for (let i = 0; i < codearray.length; i++) {
                        if (codearray[i] == x.HSN) {
                            amtarray[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        codearray.push(x.HSN);
                        amtarray.push(x.GrossAmount);
                    }
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if ( TaxApplicable) {

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;

            }

            this.form.ItemDetails.render;
        }


        protected onDialogOpen() {
            super.onDialogOpen(); 
            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");

            fieldEditor.addClass("has-inplace-button");
            $('<button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            if (isNaN(this.form.PartyId.value)) { 
                this.form.ItemDetails.PartyId = this.form.PartyId.value;


                var items = this.form.ItemDetails.getItems();
                let pieces = [];
                let weight = [];
                let itemids = [];
                items.forEach(function (value) {
                    itemids.push(value.TransItemId);
                    pieces.push(value.Pieces);
                    weight.push(value.Weight);
                });
                this.form.ItemDetails.itemids = itemids;
                this.form.ItemDetails.pieces = pieces;
                this.form.ItemDetails.weight = weight;
                this.form.ItemDetails.isUpdate = 1;
                this.form.ItemDetails.canUpdate = 0;
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, true);

            }
            else {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                this.form.GrossAmount.value = 0;
                this.form.ItemDetails.isUpdate = 0;
            }
            let useMF = q.ToBool(GetConfigValue(1022));  
            this.useMF = useMF;
            if (useMF) {
                q.showAndSetRequiredField(this.form.MF);
            } else {
                q.hideField(this.form.MF);
            }
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.PosCustomerMasterGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.PosCustomerMasterRow[]) => {

                this.form.POSCustomerId.value = selectedItems[0].POSCustomerId.toString();
                this.form.Address.value = selectedItems[0].Address;
                this.form.BirthDate.value = selectedItems[0].BirthDate;
                this.form.Anniversary.value = selectedItems[0].Anniversary;
                this.form.Mobile.value = parseFloat(selectedItems[0].Mobile);
                this.form.PanNumber.value = selectedItems[0].PanNumber;
            }
            pickerDialog.dialogOpen();

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            let companyDetails = OMS.CompanyRow.getLookup().itemById[this.form.CompanyId.value];
            this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
            this.RateListId = companyDetails.SPriceListId == null ? 0 : companyDetails.SPriceListId;
            this.LaborListId = companyDetails.SLabourListId == null ? 0 : companyDetails.SLabourListId;
            this.StoneMarkup = companyDetails.SMarkup == null ? 0 : companyDetails.SMarkup;
            //this.StoneDiscount = companyDetails.== null ? 0 : companyDetails.StnAddDisc;
            this.LaborMarkup = companyDetails.SLMarkup == null ? 0 : companyDetails.SLMarkup;
            //this.LaborDiscount = companyDetails.LbrAddDisc == null ? 0 : companyDetails.LbrAddDisc;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Retail.QuotationVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));
            //btns.push({
            //    title: 'Export',
            //    cssClass: 'send-button',
            //    onClick: () => {
            //        Q.postToService({
            //            service: POSQuotationService.baseUrl + '/EstimateExcelExport',
            //            request: {
            //                Items: this.entity.ItemDetails,
            //                VoucherNo: this.form.VoucherNo.value
            //            },

            //            target: '_blank'
            //        });
            //    }
            //});

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: POSOrderItemsRow;
            POSOrderItemsService.ValidateQuotation(
                {
                    RefTransId: parseInt(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value
                },
                response => {
                    if (response.Entities != null && response.Entities.length > 0) {
                        refid = response.Entities[0];
                    }
                }, { async: false });
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: POSOrderItemsRow;
            POSOrderItemsService.ValidateQuotation(
                {
                    RefTransId: parseInt(this.form.TransId.value),
                    RefVoucherId: this.form.VoucherTypeId.value
                },
                response => {
                    if (response.Entities != null && response.Entities.length > 0) {
                        refid = response.Entities[0];
                    }
                }, { async: false });
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                POSQuotationService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
          


        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.ProductId == null || x.ProductId.toString() == "")
                        x.ProductId = items[i].ProductId;

                    if (x.BomRate == null || x.BomRate == 0 || x.BomAmount == null || x.BomAmount == 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
                        Q.alert(msg)
                        Isvalid = false;
                    }
                })

                if (items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                        }
                    })
                }
            }

            return Isvalid;

        }

        validateEntity(row: Retail.POSQuotationRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
        }
    }
}